/** ai_prompts admin API client */
import axios from 'axios'
import { attachAuth } from '../../lib/apiAuth'
import type { PromptTemplate, PromptCreate, PromptUpdate } from '../types'

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:8899'
const api = axios.create({ baseURL: `${API_BASE}/admin/ai-prompts`, headers: { 'Content-Type': 'application/json' } })

export async function listPrompts(): Promise<PromptTemplate[]> { return (await api.get('')).data }
export async function getPrompt(id: number): Promise<PromptTemplate> { return (await api.get(`/${id}`)).data }
export async function createPrompt(body: PromptCreate): Promise<PromptTemplate> { return (await api.post('', body)).data }
export async function updatePrompt(id: number, body: PromptUpdate): Promise<PromptTemplate> { return (await api.put(`/${id}`, body)).data }
export async function activatePrompt(id: number): Promise<PromptTemplate> { return (await api.post(`/${id}/activate`)).data }
export async function deletePrompt(id: number): Promise<void> { await api.delete(`/${id}`) }

// Basic-Auth-Header + 401-Behandlung (optionaler Schutz, v0.3.8)
attachAuth(api)
